export default {
  labelUnlock: {
    id: 'product_page_carriers_unlock',
    defaultMessage: 'Works with all carriers',
  },
  labelLock: {
    id: 'product_page_carriers_lock',
    defaultMessage: 'Only compatible with',
  },
  learnMoreUnlock: {
    id: 'product_page_carriers_learn_more_unlocked',
    defaultMessage: 'Learn about unlocked phones',
  },
  learnMoreLock: {
    id: 'product_page_carriers_learn_more_locked',
    defaultMessage: 'Learn about locked phones',
  },
}
